import { themeQuartz, iconSetMaterial } from 'ag-grid-community';

export const elzTheme = themeQuartz.withPart(iconSetMaterial).withParams({
  accentColor: '#DCB9F8',
  advancedFilterBuilderButtonBarBorder: false,
  advancedFilterBuilderColumnPillColor: '#0B8A2B',
  advancedFilterBuilderJoinPillColor: '#FF4F77',
  advancedFilterBuilderOptionPillColor: '#DA7F00',
  advancedFilterBuilderValuePillColor: '#2159BF',
  backgroundColor: '#17111B',
  borderColor: '#4D4355',
  borderRadius: 4,
  browserColorScheme: 'dark',
  buttonActiveBackgroundColor: '#DCB9F8',
  buttonActiveBorder: false,
  buttonActiveTextColor: '#4B007E',
  buttonBackgroundColor: '#DCB9F8',
  buttonBorder: false,
  buttonBorderRadius: 8,
  buttonDisabledBackgroundColor: '#E6E0E91F',
  buttonDisabledBorder: true,
  buttonDisabledTextColor: '#FFFFFF40',
  buttonFontWeight: 600,
  buttonHoverBackgroundColor: '#CFADED',
  buttonHoverTextColor: '#4B007E',
  buttonTextColor: '#4B007E',
  buttonVerticalPadding: 8,
  cellEditingBorder: true,
  checkboxBorderRadius: 2,
  checkboxIndeterminateBackgroundColor: '#DCB9F8',
  checkboxIndeterminateShapeColor: '#4B007E',
  checkboxUncheckedBorderColor: '#998CA0',
  chromeBackgroundColor: '#1D1A24',
  columnDropCellBackgroundColor: '#FFFFFF14',
  columnHoverColor: '#DCB9F814',
  dragHandleColor: '#998CA0',
  dropdownShadow: '#000000AA 0px 1px 4px 1px',
  findActiveMatchBackgroundColor: '#39D9F2',
  findActiveMatchColor: '#17111B',
  findMatchBackgroundColor: '#46E1FB',
  findMatchColor: '#17111B',
  focusErrorShadow: '#FFB2BC 0px 0px 0px 3px',
  fontFamily: {
    googleFont: 'Open Sans'
  },
  fontSize: 16,
  foregroundColor: '#FFFFFF',
  fullRowEditInvalidBackgroundColor: '#670022',
  headerBackgroundColor: '#231D28',
  headerCellHoverBackgroundColor: '#DCB9F80D',
  headerFontSize: 14,
  headerFontWeight: 600,
  iconButtonActiveBackgroundColor: '#DCB9F814',
  iconButtonHoverBackgroundColor: '#DCB9F81F',
  inputBorder: true,
  inputBorderRadius: 4,
  inputDisabledBorder: true,
  inputFocusShadow: '#DCB9F880 0px 0px 0px 3px',
  menuBackgroundColor: '#17111B',
  menuTextColor: '#FFFFFF',
  oddRowBackgroundColor: '#17111B',
  panelBackgroundColor: '#231D28',
  rowLoadingSkeletonEffectColor: '#FFFFFF0D',
  selectedRowBackgroundColor: '#DCB9F814',
  sideButtonBarBackgroundColor: '#231D28',
  sideButtonHoverTextColor: '#DCB9F8',
  sideButtonSelectedBackgroundColor: '#1D1A24',
  sideButtonSelectedUnderlineColor: '#DCB9F8',
  statusBarLabelFontWeight: 400,
  statusBarValueFontWeight: 600,
  tabBackgroundColor: '#28222B',
  tabBarTopPadding: 16,
  tabBottomPadding: 12,
  tabHorizontalPadding: 16,
  tabHoverBackgroundColor: '#302A34',
  tabSelectedTextColor: '#DCB9F8',
  tabSelectedUnderlineColor: '#DCB9F8',
  tabSelectedUnderlineTransitionDuration: '0.2s',
  tabSelectedUnderlineWidth: 2,
  tabTextColor: '#FFFFFF',
  tabTopPadding: 12,
  toggleButtonOffBackgroundColor: '#DCB9F850',
  tooltipBackgroundColor: '#352E39',
  tooltipBorder: false,
  tooltipErrorBackgroundColor: '#FFB2BC',
  tooltipErrorBorder: false,
  tooltipErrorTextColor: '#510019',
  valueChangeDeltaDownColor: '#FF4F77',
  valueChangeDeltaUpColor: '#53C15A'
});
